// TODO: Why does it complain about this?
// ERROR in ./app/Models/Statamic/Components/Media.ts 17:28-59
// Module not found: Error: Can't resolve '@ioc:Adonis/Core/Env' in '/tmp/build_902ae9be/app/Models/Statamic/Components'

// import Env from '@ioc:Adonis/Core/Env';
// const statamicUrl = Env.get('STATAMIC_URL');
const STATAMIC_URL = 'https://cms.millbankhardware.com';

export default class Media {
  /** Description or alt text for the media asset. Defaults to empty string if not provided (decorative image) */
  public desc: string;
  /** Glide URL for transforms */
  public url: string;
  /** Permalink to the original media asset */
  public permalink: string;

  constructor(data: any) {
    try {
      const isSVG = data.permalink.endsWith('.svg');
      // If the URL is an SVG, we don't want to add /img, just use the asset URL.
      this.url = isSVG
        ? `${STATAMIC_URL}${data.url}`
        : `${STATAMIC_URL}/img${data.url}`;
      // Edge prints `null` as the literal string "null", so default to empty for `alt=""`.
      this.desc = data.alt ?? '';
      this.permalink = data.permalink;
    } catch (error) {
      // Logger.error(error);
    }
  }
}
